<template>
  <div class="noteBox">
    <div class="noteHead">
      <div class="headTop"></div>
      <div class="headBottom">
        <img src="../../assets/images/titleArrow.png" @click="returnTopic()" />
        <div class="title">我的笔记</div>
        <div class="num">
          笔记总数：<span>{{ noteList.length }}</span>
        </div>
      </div>
    </div>
    <ul class="noteUl" v-if="noteList.length > 0">
      <li
        class="noteLi"
        v-for="(item, index) in noteList"
        :key="index"
        @click="noteClick(item)"
      >
        <div class="liTop">
          <div class="liTopHead">
            {{ item.content }}
          </div>
          <div class="liTopContent">
            {{ item.mark }}
          </div>
        </div>
        <div class="liBottom">{{ item.updateTime }}</div>
      </li>
    </ul>
    <div v-else class="notBox">
      <img src="../../assets/images/None.png" alt="" />
      <span>暂无数据</span>
    </div>
  </div>
</template>

<script>
// import { questionResourceList } from "@/api/topic/index.js";
// 整体导入为模块对象
import * as topicApi from "@/api/topic/index.js";
import * as topicsApi from "@/api/topics/index.js";
export default {
  data() {
    return {
      studyBankId: "",
      noteList: [],
    };
  },
  computed: {
    // 根据 questionType 返回对应的 API 模块
    api() {
      return this.$route.query.questionType == 1 ? topicApi : topicsApi;
    },
  },
  created() {
    this.studyBankId = this.$route.query.studyBankId;
    this.getQuestionResourceList();
  },
  methods: {
    async getQuestionResourceList() {
      const setList = {
        studyBankId: this.studyBankId,
        isMark: 1,
      };
      const { data } = await this.api.questionResourceList(setList);
      this.noteList = data;
    },
    noteClick(item) {
      this.$router.push({
        path: "/homework",
        query: { questionId: item.questionId, typeFlag: 1, name: "note", noteContent: item.mark,questionType: this.$route.query.questionType },
      });
    },
    returnTopic() {
      this.$router.push({ path: "/topic",
        query: {
          questionType: this.$route.query.questionType,
        }
       });
    },
  },
};
</script>

<style lang="scss" scoped>
.noteBox {
  padding: 0 16px;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  .noteHead {
    margin-bottom: 12px;
    width: 100%;
    height: 88px;
    height: 88px;
    .headTop {
      width: 100%;
      height: 44px;
    }
    .headBottom {
      position: relative;
      width: 100%;
      height: 44px;
      line-height: 44px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #121212;
      text-align: center;
      font-style: normal;
      img {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
      }
      .num {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        text-align: center;
        font-style: normal;
      }
    }
  }
  .noteUl {
    width: 100%;
    // background: #ffffff;

    .noteLi {
      padding: 12px 16px 0 16px;
      margin-bottom: 10px;
      list-style: none;
      background: #ffffff;
      border-radius: 12px;
      backdrop-filter: blur(6px);
      .liTop {
        border-bottom: 1px solid #eeeeee;
        .liTopHead {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          white-space: nowrap; /* 文本不换行 */
          overflow: hidden; /* 隐藏溢出的文本 */
          text-overflow: ellipsis; /* 显示省略号 */
        }
        .liTopContent {
          margin-top: 4px;
          margin-bottom: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          display: -webkit-box; /* 将元素呈现为弹性伸缩盒子 */
          -webkit-line-clamp: 2; /* 显示的行数 */
          -webkit-box-orient: vertical; /* 垂直方向排列 */
          overflow: hidden; /* 隐藏溢出的内容 */
        }
      }
      .liBottom {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        height: 47px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        font-style: normal;
      }
    }
  }
  .notBox {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100vh - 88px);
    img {
      width: 113px;
      height: 106px;
    }
    span {
      margin-top: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #aaaaaa;
      line-height: 17px;
      text-align: center;
      font-style: normal;
    }
  }
}
</style>